import { Navigate } from 'react-router-dom'
import ForbiddenPage from './ForbiddenPage'

/**
 * Protected Route Component
 * 
 * Wraps routes that require specific roles.
 * Shows ForbiddenPage if user doesn't have required role.
 * 
 * @param {React.ReactNode} children - Content to render if authorized
 * @param {Array<string>} allowedRoles - Array of roles allowed to access (e.g., ['admin'], ['admin', 'editor'])
 * @param {Object} adminData - Current user data with role
 */
const ProtectedRoute = ({ children, allowedRoles, adminData }) => {
  // Loading state - wait for auth data
  if (!adminData) {
    return (
      <div className="bg-white rounded-lg shadow p-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Vérification des permissions...</p>
      </div>
    )
  }

  // No role assigned - shouldn't happen but fail secure
  if (!adminData.role) {
    console.warn('⚠️ User has no role assigned')
    return <Navigate to="/admin/dashboard" replace />
  }

  // Check if user's role is in the allowed roles list
  const isAuthorized = allowedRoles.includes(adminData.role)

  if (!isAuthorized) {
    console.warn(`🚫 Unauthorized access attempt: ${adminData.email} (${adminData.role}) tried to access route restricted to [${allowedRoles.join(', ')}]`)
    return <ForbiddenPage adminData={adminData} allowedRoles={allowedRoles} />
  }

  // User is authorized, render the protected content
  return children
}

export default ProtectedRoute

